<template>
  <div id="campus-documents">
    <Header
      :page="'documents'"
      :title_one="'documents'"
      :action_one="'edit'"
      :person_id="participant.id"
      :banner_docsok_msg="doc_ok"
    ></Header>

    <ErrorPopup
      @close="goToDocumentation()"
      @input="goToDocumentation()"
      :dialog="dialog"
      :message="message"
    ></ErrorPopup>

    <div style="margin: 10px 0">
      <a
        target="_blank"
        style="font-size: 16px; font-weight: bold; color: #172654"
        href="https://helpx.adobe.com/es/reader/using/sign-pdfs.html"
        >{{ $t("descriptions.download_sign_documents") }}</a
      >
      <br /><br />
      <span
        class="info"
        v-html="$t('descriptions.form_documents_sign_description')"
      ></span>
    </div>

    <div id="info_documents">
      <div class="left">
        <div class="title">
          {{ $t("titles.medicaments_allergies_and_intolerances") }}
        </div>
        <div class="row">
          <!-- ANTITERMIC -->
          <div class="item mid" v-if="+event.type_id === 4">
            <div class="label">{{ $t("params.auth_antitermic") }}</div>
            <div class="value">
              {{
                participant.antitermic == "1" ? $t("bool.si") : $t("bool.no")
              }}
            </div>
          </div>
          <!-- ALLERGIES -->
          <div class="item mid">
            <div class="label">{{ $t("params.allergies_intolerances") }}</div>
            <div class="value">{{ participant.allergies_intolerances }}</div>
          </div>
          <!-- REACTIONS ALLERGIES -->
          <div class="item mid">
            <div class="label">{{ $t("params.allergic_reactions") }}</div>
            <div class="value">{{ participant.allergic_reactions }}</div>
          </div>
          <!-- WHAT TO DO ALLERGIES -->
          <div class="item mid">
            <div class="label">{{ $t("params.what_to_do_allergy") }}</div>
            <div class="value">{{ participant.what_to_do_allergy }}</div>
          </div>
          <!-- MEDICINES -->
          <div class="item mid">
            <div class="label">{{ $t("params.medicamento") }}</div>
            <div class="value">{{ participant.medicamentos }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">{{ $t("titles.external") }}</div>
        <div class="row">
          <!-- ANTITERMIC -->
          <div class="item mid">
            <div class="label">{{ $t("params.participant_goes_alone") }}</div>
            <div class="value">
              {{
                participant.alone_home == "1" ? $t("bool.si") : $t("bool.no")
              }}
            </div>
          </div>
          <!-- ANTITERMIC -->
          <div class="item mid" v-if="participant.alone_home != '1'">
            <div class="label">{{ $t("params.people_authorize") }}</div>
            <div class="value">{{ participant.externos }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="title">{{ $t("titles.documents_campus_sign") }}</div>

    <div class="container">
      <div
        class="row"
        v-for="(document, i) in documents_to_sign"
        :key="i"
        :class="[
          { default: document.status == null },
          { to_validate: document.status == 1 },
          { validated: document.status == 2 },
          { error_document: document.status == 3 },
        ]"
      >
        <!-- TITLE -->
        <div class="description">
          <h5>
            {{
              $t(
                "titles." +
                  (document.type == "rest_documents" &&
                  (+event.type_id === 12 || +event.type_id === 13)
                    ? "rest_documents_2"
                    : document.type)
              )
            }}
          </h5>
        </div>
        <div>
          <div class="instructions">
            <!-- <template v-if="document.status == null">
              <p class="">{{ $t("descriptions.pdf_format") }}</p>
            </template> -->
            <template v-if="document.status == 1">
              <p class="bold">{{ $t("descriptions.mic_validation") }}</p>
            </template>
            <template v-if="document.status == 2">
              <p class="bold">{{ $t("descriptions.valit_document") }}</p>
            </template>
            <template v-if="document.status == 3 && !document.reject">
              <p class="bold">{{ $t("descriptions.invalit_document") }}</p>
            </template>
            <template v-else-if="+document.status === 3">
              <p class="bold">
                {{
                  $t(
                    rejectDocuments[document.reject]
                      ? rejectDocuments[document.reject].name
                      : ""
                  )
                }}
              </p>
              <p class="">
                {{
                  $t(
                    rejectDocuments[document.reject]
                      ? rejectDocuments[document.reject].description
                      : ""
                  )
                }}
              </p>
            </template>
          </div>
        </div>
        <div class="doc-actions">
          <!-- DOWNLOAD -->
          <!-- <div class="item" v-if="document.status != 2">
            <button @click="download(document)" class="secondary">
              {{ $t("download") }}
            </button>
          </div> -->

          <!-- UPLOAD -->
          <!-- <div class="item" v-if="document.status != 2">
            <input
              :class="''"
              type="file"
              :ref="document.type"
              accept="application/pdf"
              style="display: none"
              @change="upload(document)"
            />
            <button @click="selectImage(document)">
              {{ $t("upload_file") }}
            </button>
          </div> -->

          <!-- SIGN -->
          <div class="item" v-if="document.status != 2">
            <button @click="sign(document)" class="secondary">
              {{ $t("sign") }}
            </button>
          </div>

          <!-- PREVIEW -->
          <!-- <div class="item" v-if="document.status != null">
            <button @click="previewDocument(document)" class="secondary">
              {{ $t("preview") }}
            </button>
          </div> -->
        </div>
      </div>
    </div>

    <div class="title" v-if="documents_to_upload.length > 0">
      {{ $t("titles.documents_campus_upload") }}
    </div>
    <div class="container" v-if="documents_to_upload.length > 0">
      <div
        class="row"
        v-for="(document, i) in documents_to_upload"
        :key="i"
        :class="[
          { default: document.status == null },
          { to_validate: document.status == 1 },
          { validated: document.status == 2 },
          { error_document: document.status == 3 },
        ]"
      >
        <!-- TITLE -->
        <div class="description">
          <h5>{{ $t("titles." + document.type) }}</h5>
        </div>
        <div>
          <div class="instructions">
            <template v-if="document.status == null">
              <p class="">{{ $t("descriptions.pdf_format") }}</p>
            </template>
            <template v-if="document.status == 1">
              <p class="bold">{{ $t("descriptions.mic_validation") }}</p>
            </template>
            <template v-if="document.status == 2">
              <p class="bold">{{ $t("descriptions.valit_document") }}</p>
            </template>
            <template v-if="document.status == 3">
              <p class="bold">{{ $t("descriptions.invalit_document") }}</p>
            </template>
          </div>
        </div>
        <div class="doc-actions">
          <!-- UPLOAD -->
          <div class="item" v-if="document.status != 2">
            <input
              :class="''"
              type="file"
              :ref="document.type"
              accept="application/pdf"
              style="display: none"
              @change="upload(document)"
            />
            <button @click="selectImage(document)">
              {{ $t("upload_file") }}
            </button>
          </div>

          <!-- PREVIEW -->
          <div class="item" v-if="document.status != null">
            <button @click="previewDocument(document)" class="secondary">
              {{ $t("preview") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="false && documents_to_print_1day.length > 0" class="title">
      {{ $t("titles.documents_campus_print_1day") }}
    </div>
    <div v-if="false && documents_to_print_1day.length > 0" class="container">
      <div
        class="row default"
        v-for="(document, i) in documents_to_print_1day"
        :key="i"
      >
        <!-- TITLE -->
        <div class="description">
          <h5>{{ $t("titles." + document.type) }}</h5>
        </div>
        <div class="instructions">
          <template v-if="document.type == 'basic_criteria'">
            <p class="">{{ $t("descriptions.basic_criteria") }}</p>
          </template>
        </div>
        <div class="doc-actions">
          <div class="item" v-if="document.status != 2">
            <button @click="download(document)" class="secondary">
              {{ $t("download") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="documents_to_print.length > 0" class="title">
      {{ $t("titles.documents_campus_print") }}
    </div>
    <div v-if="documents_to_print.length > 0" class="container">
      <div
        class="row default"
        v-for="(document, i) in documents_to_print"
        :key="i"
      >
        <!-- TITLE -->
        <div class="description">
          <h5>{{ $t("titles." + document.type) }}</h5>
        </div>
        <div class="doc-actions">
          <div class="item" v-if="document.status != 2">
            <button @click="download(document)" class="secondary">
              {{ $t("download") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :top="true"
      :vertical="false"
    >
      {{ text }}
      <v-btn
        style="color: red; font-weight: bold; font-size: 16px"
        flat
        @click="snackbar = false"
      >
        X
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
/* global moment, trim */
import i18n from '@/i18n'
import Header from '@/components/layout/Header'
import ErrorPopup from '@/components/ui/ErrorPopup.vue'

export default {
  name: 'campus_documents',
  components: {
    Header,
    ErrorPopup
  },
  data () {
    return {
      participant: {},

      files: {
        image_right: ''
      },

      error: {
        image_right: {
          format_document: false,
          upload: false
        }
      },

      dialog: false,
      message: '',
      snackbar: false,
      text: '',
      doc_ok: true
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },

    rejectDocuments () {
      return this.$store.getters['getRejectDocuments']()
    },

    event () {
      return this.$store.getters.getCurrentEvent()
    },

    documents_to_sign () {
      var participant = this.$store.getters['person/getPerson']
      var event = this.$store.getters.getCurrentEvent()
      var docs = []
      if (+event.type_id === 4) {
        docs.push({
          type: 'image-rights',
          status: participant.image_right_status,
          preview: participant.image_right,
          reject: participant.image_right_reject
            ? parseInt(participant.image_right_reject)
            : null
        })
        docs.push({
          type: 'rest_documents',
          status: participant.medicines_status,
          preview: participant.medicines,
          reject: participant.medicines_reject
            ? parseInt(participant.medicines_reject)
            : null
        })
      } else if (+event.type_id === 12 || +event.type_id === 13 || +event.type_id === 16) {
        docs.push({
          type: 'image-rights',
          status: participant.image_right_status,
          preview: participant.image_right,
          reject: participant.image_right_reject
            ? parseInt(participant.image_right_reject)
            : null
        })
        docs.push({
          type: 'rest_documents',
          status: participant.medicines_status,
          preview: participant.medicines,
          reject: participant.medicines_reject
            ? parseInt(participant.medicines_reject)
            : null
        })
      } else {
        docs.push({
          type: 'image-rights',
          status: participant.image_right_status,
          preview: participant.image_right,
          reject: participant.image_right_reject
            ? parseInt(participant.image_right_reject)
            : null
        })
      }
      return docs
    },

    documents_to_upload () {
      var participant = this.$store.getters['person/getPerson']
      var event = this.$store.getters.getCurrentEvent()
      var docs = []
      if (+event.type_id === 4) {
        // docs.push({
        //   type: "vaccination",
        //   status: participant.vaccination_status,
        //   preview: participant.vaccination
        // });
      } else if (+event.type_id === 12 || +event.type_id === 13 || +event.type_id === 16) {
        // docs.push({
        //   type: "vaccination",
        //   status: participant.vaccination_status,
        //   preview: participant.vaccination
        // });
        docs.push({
          type: 'medic_card',
          status: participant.medic_card_status,
          preview: participant.medic_card
        })
      } else {
      }
      return docs
    },

    documents_to_print_1day () {
      var event = this.$store.getters.getCurrentEvent()
      var docs = []
      if (+event.type_id === 4) {
        // docs.push({
        //   type: 'basic_criteria'
        // })
        // docs.push({
        //   type: 'doc_family'
        // })
      } else if (+event.type_id === 12 || +event.type_id === 13) {
        // docs.push({
        //   type: 'basic_criteria'
        // })
        // docs.push({
        //   type: 'doc_family'
        // })
      } else {
      }
      return docs
    },

    documents_to_print () {
      var event = this.$store.getters.getCurrentEvent()
      var docs = []
      // if (+event.type_id === 4 || +event.type_id === 12) {
      //     docs.push({ type: "doc_camper" });
      //   }

      if (event.type_id == 4) {
        docs.push({ type: "doc_information" });
        // docs.push({ type: "doc_llegada_salida" });
        // docs.push({ type: "doc_hotel" });
        // docs.push({ type: 'doc_bag' })
        // docs.push({ type: "doc_include" });
        // docs.push({ type: 'doc_rooms' })
        // docs.push({ type: "doc_externos" });
        // docs.push({ type: "doc_bus" });
        // docs.push({ type: "doc_firstday" });
        // docs.push({ type: "doc_contact" });
        //     docs.push({ type: "doc_higienic" });
        //     docs.push({ type: "doc_ofertas" });
        // docs.push({ type: "doc_bus_2" });
        // docs.push({ type: "doc_final_basket" });
        // docs.push({ type: "doc_final_futbol" });
        // docs.push({ type: "doc_day" });
      } else if (+event.type_id === 12) {
        docs.push({ type: "doc_information" });
        // docs.push({ type: "doc_food" });
        // docs.push({ type: "doc_llegada_salida" });
        // docs.push({ type: "doc_bag" });
        // docs.push({ type: "doc_hotel" });
        // docs.push({ type: "doc_include" });
        // docs.push({ type: "doc_llegada_salida_bcn" });
        //     docs.push({ type: "doc_llegada_salida_te" });
        // docs.push({ type: "doc_firstday_bcn" });
        //     docs.push({ type: "doc_firstday_te" });
        //     docs.push({ type: "doc_higienic" });
        //     docs.push({ type: "doc_smallbag" });
        // docs.push({ type: "doc_day" });
      } else if (+event.type_id === 13) {
        // docs.push({ type: "doc_information" });
        // docs.push({ type: "doc_llegada_salida" });
        // docs.push({ type: "doc_firstday" });
        // // docs.push({ type: "doc_pool" });
        // docs.push({ type: "doc_smallbag" });
        // docs.push({ type: "doc_day" });
      } else if (+event.type_id === 12 || +event.type_id === 13) {
        //     // docs.push({
        //     //   type: "doc_simptomes"
        //     // });
      } else if (+event.type_id === 5) {
        docs.push({ type: 'doc_food' })
        docs.push({ type: 'doc_food_en' })
        // docs.push({ type: "doc_info" });
        // docs.push({ type: "doc_contact" });
        docs.push({ type: 'doc_internos' })
        docs.push({ type: 'doc_boarders' })
        docs.push({ type: 'doc_externos' })
        docs.push({ type: 'doc_non_boarders' })
        docs.push({ type: 'doc_rising_stars_es' })
        docs.push({ type: 'doc_rising_stars_en' })
        docs.push({ type: 'doc_schedule_es' })
        docs.push({ type: 'doc_schedule_en' })
      }

      return docs
    }
  },
  created () {
    // save campus
    this.$store.commit('setCampus', true)
    this.load()
  },
  methods: {
    load () {
      var self = this

      this.$store
        .dispatch('person/loadPersonCampus', {
          campus_id: this.user.event_id,
          participant_id: this.user.participant_id
        })
        .then(function () {
          self.participant = self.$store.getters['person/getPerson']
          if (self.participant.allergies) {
            var allergies = JSON.parse(self.participant.allergies)
            self.participant.what_to_do_allergy = allergies.wd
              ? allergies.wd
              : ''
            if (allergies.a) {
              self.participant.allergies_intolerances = ''
              allergies.a.forEach((allergy) => {
                if (self.participant.allergies_intolerances) {
                  self.participant.allergies_intolerances += ', '
                }
                self.participant.allergies_intolerances += allergy
              })
            }
            if (allergies.r) {
              self.participant.allergic_reactions = ''
              allergies.r.forEach((allergy) => {
                if (self.participant.allergic_reactions) {
                  self.participant.allergic_reactions += ', '
                }
                self.participant.allergic_reactions += allergy
              })
            }
          }
          if (self.participant.externals) {
            var aExternals = JSON.parse(self.participant.externals)
            self.participant.externos = ''
            aExternals.forEach((external) => {
              if (external && trim(external.name)) {
                if (self.participant.externos) {
                  self.participant.externos += ', '
                }
                self.participant.externos +=
                  external.name + ' ' + external.surname + ' - ' + external.dni
              }
            })
          }
          if (self.participant.medicaments) {
            var aMedicines = JSON.parse(self.participant.medicaments)
            self.participant.medicmanetos = ''
            aMedicines.forEach((medicine) => {
              if (self.participant.medicmanetos) {
                self.participant.medicmanetos += ', '
              }
              self.participant.medicmanetos += medicine.name
            })
          }
          if (
                (!person.antithermal && [4, 5].includes(self.event.type_id)) ||
                !person.medicines ||
                !person.externals ||
                !person.image_right
            ) {
                self.doc_ok = false
            }
        })
    },

    closePopup () {
      this.dialog = false
    },

    goToDocumentation () {
      this.dialog = false
      this.$router
        .push({
          name: 'participant_campus_edit',
          params: {
            person_id: this.participant.id
          }
        })
        .catch()
    },

    downloadImageRights () {
      window.open(
        process.env.VUE_APP_API_URL +
          'participant/' +
          this.user.participant_id +
          '/imagerights/' +
          this.user.event_id +
          '/' +
          this.user.language +
          '/' +
          localStorage.token +
          '?' +
          moment().unix()
      )
    },

    sign (document) {
      var self = this
      var languages = this.$store.getters.getLanguages
      if (document.type === 'image-rights') {
        this.$store
          .dispatch('person/sendImageRight', {
            id: this.participant.id,
            event_id: this.user.event_id,
            type: 'player',
            lang: languages[this.participant.lang].name
          })
          .then(function () {
            self.text = i18n.t('image_right.messages.link_sended')
            self.snackbar = true
          })
      } else {
        var allergies = this.participant.allergies
          ? JSON.parse(this.participant.allergies)
          : false

        if (
          (!this.participant.medicines && !allergies) ||
          !this.participant.externals
        ) {
          this.dialog = true
          this.message = 'campus.errors.documents.required'
        } else {
          this.$store
            .dispatch('person/sendDocument', {
              document: document.type,
              id: this.participant.id,
              event_id: this.user.event_id,
              type: 'player',
              lang: languages[this.participant.lang].name
            })
            .then(function () {
              self.text = i18n.t('image_right.messages.link_sended')
              self.snackbar = true
            })
        }
      }
    },

    download (document) {
      if (
        ['image-rights', 'antithermal', 'medicines', 'external'].includes(
          document.type
        )
      ) {
        var validate = true
        if (document.type === 'antithermal') {
          if (!this.participant.antitermic) {
            validate = false
            this.dialog = true
            this.message = 'campus.errors.documents.required'
          }
        } else if (document.type === 'medicines') {
          var allergies = this.participant.allergies
            ? JSON.parse(this.participant.allergies)
            : false
          if (!this.participant.medicines && !allergies) {
            validate = false
            this.dialog = true
            this.message = 'campus.errors.documents.required'
          }
        } else if (document.type === 'external') {
          if (!this.participant.externals) {
            validate = false
            this.dialog = true
            this.message = 'campus.errors.documents.required'
          }
        }

        if (validate) {
          var languages = this.$store.getters.getLanguages
          window.open(
            process.env.VUE_APP_API_URL +
              'participant/' +
              this.user.participant_id +
              '/' +
              document.type +
              '/' +
              this.user.event_id +
              '/' +
              languages[this.participant.lang].name +
              '/' +
              localStorage.token +
              '' // "/?" +
            // moment().unix()
          )
        }
      } else {
        var event = this.$store.getters.getCurrentEvent()
        if (+event.type_id === 4) {
          switch (document.type) {
            case 'antithermal':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'Antitermico_CAT.pdf?' + moment().valueOf()
                    : 'Antitermico_ESP.pdf?' + moment().valueOf())
              )
              break
            case 'medicines':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'Medicaments&Al·lergies_AND_CAT.pdf?' + moment().valueOf()
                    : 'Medicaments&Al·lergies_AND_CAST.pdf?' +
                      moment().valueOf())
              )
              break
            case 'external':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'Recollida participants_NCAND_CAT.pdf?' +
                      moment().valueOf()
                    : 'Recollida participants_NCAND_CAST.pdf?' +
                      moment().valueOf())
              )
              break
            case 'basic_criteria':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? "CRITERIS BASICS ACTIVITATS ESPORTIVES D'ESTIU-amb annex  fase 3.pdf?" +
                      moment().valueOf()
                    : "CRITERIS BASICS ACTIVITATS ESPORTIVES D'ESTIU-amb annex  fase 3.pdf?" +
                      moment().valueOf())
              )
              break
            case 'doc_include':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'QUE_INCLUYE_EL_CAMPUS.pdf?' + moment().valueOf()
                    : 'QUE_INCLUYE_EL_CAMPUS.pdf?' + moment().valueOf())
              )
              break
            case 'doc_family':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'FORMULARI DECLARACIÓ RESPONSABLE.pdf?' +
                      moment().valueOf()
                    : 'FORMULARI DECLARACIÓ RESPONSABLE.pdf?' +
                      moment().valueOf())
              )
              break
            case 'doc_camper':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC21_GUIA_CAMPERS_AND.pdf?' + moment().valueOf()
                    : 'MC21_GUIA_CAMPERS_AND.pdf?' + moment().valueOf())
              )
              break
            case 'doc_rooms':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC25_AND_HABITACIONES.pdf?' + moment().valueOf()
                    : 'MC25_AND_HABITACIONES.pdf?' + moment().valueOf())
              )
              break
            case 'doc_llegada_salida':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC22_AND_LLEGADA_SALIDA.pdf?' + moment().valueOf()
                    : 'MC22_AND_LLEGADA_SALIDA.pdf?' + moment().valueOf())
              )
              break
            case 'doc_information':
              window.open(
                "https://api.micsports.es/static/document/nikeand/" +
                  (this.user.language == "ca"
                    ? "MC26_AND_INFORMACION.pdf?" + moment().valueOf()
                    : "MC26_AND_INFORMACION.pdf?" + moment().valueOf())
              );
              break;
            case "doc_externos":
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC23_AND_EXTERNOS.pdf?' + moment().valueOf()
                    : 'MC23_AND_EXTERNOS.pdf?' + moment().valueOf())
              )
              break
            case 'doc_bus':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC24_AND_TRANSPORTE.pdf?' + moment().valueOf()
                    : 'MC24_AND_TRANSPORTE.pdf?' + moment().valueOf())
              )
              break
            case 'doc_hotel':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC23_AND_ALOJAMIENTO.pdf?' + moment().valueOf()
                    : 'MC23_AND_ALOJAMIENTO.pdf?' + moment().valueOf())
              )
              break
            case 'doc_contact':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC23_AND_CONTACTO.pdf?' + moment().valueOf()
                    : 'MC23_AND_CONTACTO.pdf?' + moment().valueOf())
              )
              break
            case 'doc_firstday':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC24_AND_PRIMER_DIA.pdf?' + moment().valueOf()
                    : 'MC24_AND_PRIMER_DIA.pdf?' + moment().valueOf())
              )
              break
            case 'doc_higienic':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC21_AND_MEDIDAS_HIGIENICAS.pdf?' + moment().valueOf()
                    : 'MC21_AND_MEDIDAS_HIGIENICAS.pdf?' + moment().valueOf())
              )
              break
            case 'doc_bag':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC25_MOCHILA.pdf?' + moment().valueOf()
                    : 'MC25_MOCHILA.pdf?' + moment().valueOf())
              )
              break
            case 'doc_ofertas':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC21_Ofertas_Andorra.pdf?' + moment().valueOf()
                    : 'MC21_Ofertas_Andorra.pdf?' + moment().valueOf())
              )
              break
            case 'doc_bus_2':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC23_AND_SALIDA_BUSES.pdf?' + moment().valueOf()
                    : 'MC23_AND_SALIDA_BUSES.pdf?' + moment().valueOf())
              )
              break
            case 'doc_final_basket':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC23_AND_FINALS_BASKET.pdf?' + moment().valueOf()
                    : 'MC23_AND_FINALS_BASKET.pdf?' + moment().valueOf())
              )
              break
            case 'doc_final_futbol':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC24_AND_FINALS_FUTBOL.pdf?' + moment().valueOf()
                    : 'MC24_AND_FINALS_FUTBOL.pdf?' + moment().valueOf())
              )
              break
            case 'doc_day':
              window.open(
                'https://api.micsports.es/static/document/nikeand/' +
                  (this.user.language === 'ca'
                    ? 'MC22_AND_PROGRAMA_DIARIO.pdf?' + moment().valueOf()
                    : 'MC22_AND_PROGRAMA_DIARIO.pdf?' + moment().valueOf())
              )
              break
          }
        } else if (+event.type_id === 12) {
          switch (document.type) {
            // case "antithermal":
            //   window.open(
            //     "https://api.micsports.es/static/document/nikebcn/" +
            //       (this.user.language == "ca"
            //         ? "Antitermico_CAT.pdf?" + moment().valueOf()
            //         : "Antitermico_ESP.pdf?" + moment().valueOf())
            //   );
            //   break;
            case 'medicines':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'Medicaments&Al·lergies_CAT.pdf?' + moment().valueOf()
                    : 'Medicaments&Al·lergies_CAST.pdf?' + moment().valueOf())
              )
              break
            case 'external':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'Recollida participants_CAT.pdf?' + moment().valueOf()
                    : 'Recollida participants_CAST.pdf?' + moment().valueOf())
              )
              break
            case 'basic_criteria':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? "CRITERIS BASICS ACTIVITATS ESPORTIVES D'ESTIU-amb annex  fase 3.pdf?" +
                      moment().valueOf()
                    : "CRITERIS BASICS ACTIVITATS ESPORTIVES D'ESTIU-amb annex  fase 3.pdf?" +
                      moment().valueOf())
              )
              break
            case 'doc_family':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'FORMULARI DECLARACIÓ RESPONSABLE.pdf?' +
                      moment().valueOf()
                    : 'FORMULARI DECLARACIÓ RESPONSABLE.pdf?' +
                      moment().valueOf())
              )
              break
            case 'doc_simptomes':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'Llistat-de-comprovacio-de-simptomes.pdf?' +
                      moment().valueOf()
                    : 'Llistat-de-comprovacio-de-simptomes.pdf?' +
                      moment().valueOf())
              )
              break
            case 'doc_camper':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'MC21_GUIA_CAMPERS_BCN_TE.pdf?' + moment().valueOf()
                    : 'MC21_GUIA_CAMPERS_BCN_TE.pdf?' + moment().valueOf())
              )
              break
            case 'doc_llegada_salida_bcn':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'MC23_LLEGADA_SALIDA_BCN.pdf?' + moment().valueOf()
                    : 'MC23_LLEGADA_SALIDA_BCN.pdf?' + moment().valueOf())
              )
              break
            case 'doc_llegada_salida_te':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'MC21_LLEGADA_RECOGIDA_TE.pdf?' + moment().valueOf()
                    : 'MC21_LLEGADA_RECOGIDA_TE.pdf?' + moment().valueOf())
              )
              break
            case 'doc_higienic':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'MC21_MEDIDAS_HIGIENICAS_BCN_TE.pdf?' + moment().valueOf()
                    : 'MC21_MEDIDAS_HIGIENICAS_BCN_TE.pdf?' +
                      moment().valueOf())
              )
              break
            case 'doc_bag':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'MC25_MOCHILA.pdf?' + moment().valueOf()
                    : 'MC25_MOCHILA.pdf?' + moment().valueOf())
              )
              break
            case 'doc_smallbag':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'MC21_MOCHILA_BCN_TE.pdf?' + moment().valueOf()
                    : 'MC21_MOCHILA_BCN_TE.pdf?' + moment().valueOf())
              )
              break
            case 'doc_firstday_bcn':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'MC22_PRIMER_DIA_BCN.pdf?' + moment().valueOf()
                    : 'MC22_PRIMER_DIA_BCN.pdf?' + moment().valueOf())
              )
              break
            case 'doc_firstday_te':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'MC21_PRIMER_DIA_TE.pdf?' + moment().valueOf()
                    : 'MC21_PRIMER_DIA_TE.pdf?' + moment().valueOf())
              )
              break
            case 'doc_day':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'MC23_PROGRAMA_DIARIO_BCN.pdf?' + moment().valueOf()
                    : 'MC23_PROGRAMA_DIARIO_BCN.pdf?' + moment().valueOf())
              )
              break
            case 'doc_information':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'MC26_BCN_INFORMACION.pdf?' + moment().valueOf()
                    : 'MC26_BCN_INFORMACION.pdf?' + moment().valueOf())
              )
              break

            case 'doc_food':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'MC24_MENUS.pdf?' + moment().valueOf()
                    : 'MC24_MENUS.pdf?' + moment().valueOf())
              )
              break
          }
        } else if (+event.type_id === 13) {
          switch (document.type) {
            case 'medicines':
              window.open(
                'https://api.micsports.es/static/document/md/' +
                  (this.user.language === 'ca'
                    ? 'Medicaments&Al·lergies_CAT_MD.pdf?' + moment().valueOf()
                    : 'Medicaments&Al·lergies_CAST_MD.pdf?' +
                      moment().valueOf())
              )
              break
            case 'external':
              window.open(
                'https://api.micsports.es/static/document/md/' +
                  (this.user.language === 'ca'
                    ? 'Recollida participants_NCDAYCAMP_CAT_MD.pdf?' +
                      moment().valueOf()
                    : 'Recollida participants_MD_CAST.pdf?' +
                      moment().valueOf())
              )
              break
            case 'basic_criteria':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? "CRITERIS BASICS ACTIVITATS ESPORTIVES D'ESTIU-amb annex  fase 3.pdf?" +
                      moment().valueOf()
                    : "CRITERIS BASICS ACTIVITATS ESPORTIVES D'ESTIU-amb annex  fase 3.pdf?" +
                      moment().valueOf())
              )
              break
            case 'doc_family':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'FORMULARI DECLARACIÓ RESPONSABLE.pdf?' +
                      moment().valueOf()
                    : 'FORMULARI DECLARACIÓ RESPONSABLE.pdf?' +
                      moment().valueOf())
              )
              break
            case 'doc_simptomes':
              window.open(
                'https://api.micsports.es/static/document/nikebcn/' +
                  (this.user.language === 'ca'
                    ? 'Llistat-de-comprovacio-de-simptomes.pdf?' +
                      moment().valueOf()
                    : 'Llistat-de-comprovacio-de-simptomes.pdf?' +
                      moment().valueOf())
              )
              break
            case 'doc_llegada_salida':
              window.open(
                'https://api.micsports.es/static/document/md/' +
                  (this.user.language === 'ca'
                    ? 'MD23_Llegada_recogida.pdf?' + moment().valueOf()
                    : 'MD23_Llegada_recogida.pdf?' + moment().valueOf())
              )
              break
            case 'doc_higienic':
              window.open(
                'https://api.micsports.es/static/document/md/' +
                  (this.user.language === 'ca'
                    ? 'MD21_Medidas_Higienicas.pdf?' + moment().valueOf()
                    : 'MD21_Medidas_Higienicas.pdf?' + moment().valueOf())
              )
              break
            case 'doc_smallbag':
              window.open(
                'https://api.micsports.es/static/document/md/' +
                  (this.user.language === 'ca'
                    ? 'MD23_Mochila.pdf?' + moment().valueOf()
                    : 'MD23_Mochila.pdf?' + moment().valueOf())
              )
              break
            case 'doc_firstday':
              window.open(
                'https://api.micsports.es/static/document/md/' +
                  (this.user.language === 'ca'
                    ? 'MD23_Primer_dia.pdf?' + moment().valueOf()
                    : 'MD23_Primer_dia.pdf?' + moment().valueOf())
              )
              break
            case 'doc_day':
              window.open(
                'https://api.micsports.es/static/document/md/' +
                  (this.user.language === 'ca'
                    ? 'MD23_Programa_diario.pdf?' + moment().valueOf()
                    : 'MD23_Programa_diario.pdf?' + moment().valueOf())
              )
              break
            case 'doc_pool':
              window.open(
                'https://api.micsports.es/static/document/md/' +
                  (this.user.language === 'ca'
                    ? 'MD22_Piscina.pdf?' + moment().valueOf()
                    : 'MD22_Piscina.pdf?' + moment().valueOf())
              )
              break
            case 'doc_information':
              window.open(
                'https://api.micsports.es/static/document/md/' +
                  (this.user.language === 'ca'
                    ? 'MD24_INFORMACION.pdf?' + moment().valueOf()
                    : 'MD24_INFORMACION.pdf?' + moment().valueOf())
              )
              break
          }
        } else if (+event.type_id === 5) {
          switch (document.type) {
            case 'doc_food':
              window.open(
                'https://api.micsports.es/static/document/pga/' +
                  (this.user.language === 'ca'
                    ? 'PGA23_MENUS_ES.pdf?' + moment().valueOf()
                    : 'PGA23_MENUS_ES.pdf?' + moment().valueOf())
              )
              break
            case 'doc_food_en':
              window.open(
                'https://api.micsports.es/static/document/pga/' +
                  (this.user.language === 'ca'
                    ? 'PGA23_MENUS_EN.pdf?' + moment().valueOf()
                    : 'PGA23_MENUS_EN.pdf?' + moment().valueOf())
              )
              break
            case 'doc_info':
              window.open(
                'https://api.micsports.es/static/document/pga/' +
                  (this.user.language === 'ca'
                    ? 'PGA22_INFORMACION.pdf?' + moment().valueOf()
                    : 'PGA22_INFORMACION.pdf?' + moment().valueOf())
              )
              break
            case 'doc_internos':
              window.open(
                'https://api.micsports.es/static/document/pga/' +
                  (this.user.language === 'ca'
                    ? 'PGA23_INTERNOS.pdf?' + moment().valueOf()
                    : 'PGA23_INTERNOS.pdf?' + moment().valueOf())
              )
              break
            case 'doc_boarders':
              window.open(
                'https://api.micsports.es/static/document/pga/' +
                  (this.user.language === 'ca'
                    ? 'PGA23_BOARDERS.pdf?' + moment().valueOf()
                    : 'PGA23_BOARDERS.pdf?' + moment().valueOf())
              )
              break
            case 'doc_externos':
              window.open(
                'https://api.micsports.es/static/document/pga/' +
                  (this.user.language === 'ca'
                    ? 'PGA23_EXTERNOS.pdf?' + moment().valueOf()
                    : 'PGA23_EXTERNOS.pdf?' + moment().valueOf())
              )
              break
            case 'doc_non_boarders':
              window.open(
                'https://api.micsports.es/static/document/pga/' +
                  (this.user.language === 'ca'
                    ? 'PGA23_NON_BOARDERS.pdf?' + moment().valueOf()
                    : 'PGA23_NON_BOARDERS.pdf?' + moment().valueOf())
              )
              break
            case 'doc_rising_stars_es':
              window.open(
                'https://api.micsports.es/static/document/pga/' +
                  (this.user.language === 'ca'
                    ? 'PGA23_RISING_STARS_ES.pdf?' + moment().valueOf()
                    : 'PGA23_RISING_STARS_ES.pdf?' + moment().valueOf())
              )
              break
            case 'doc_rising_stars_en':
              window.open(
                'https://api.micsports.es/static/document/pga/' +
                  (this.user.language === 'ca'
                    ? 'PGA23_RISING_STARS_EN.pdf?' + moment().valueOf()
                    : 'PGA23_RISING_STARS_EN.pdf?' + moment().valueOf())
              )
              break
            case 'doc_schedule_es':
              window.open(
                'https://api.micsports.es/static/document/pga/' +
                  (this.user.language === 'ca'
                    ? 'PGA23_SCHEDULE_ES.pdf?' + moment().valueOf()
                    : 'PGA23_SCHEDULE_ES.pdf?' + moment().valueOf())
              )
              break
            case 'doc_schedule_en':
              window.open(
                'https://api.micsports.es/static/document/pga/' +
                  (this.user.language === 'ca'
                    ? 'PGA23_SCHEDULE_EN.pdf?' + moment().valueOf()
                    : 'PGA23_SCHEDULE_EN.pdf?' + moment().valueOf())
              )
              break
            case 'doc_contact':
              window.open(
                'https://api.micsports.es/static/document/pga/' +
                  (this.user.language === 'ca'
                    ? 'PGA23_CONTACT_ES.pdf?' + moment().valueOf()
                    : 'PGA23_CONTACT_ES.pdf?' + moment().valueOf())
              )
              break
          }
        }
      }
    },

    upload (document) {
      var self = this
      var files = []
      //   Object.entries(this.files).forEach(([key]) => {
      //     if (typeof self.$refs[key].files[0] !== 'undefined') {
      //       if (self.$refs[key].files[0].type == 'application/pdf') {
      //         files[key] = self.$refs[key].files[0]
      //       }
      //     }
      //   })
      if (typeof self.$refs[document.type][0].files[0] !== 'undefined') {
        console.log('ENTRO...')
        if (
          self.$refs[document.type][0].files[0].type === 'application/pdf' &&
          self.$refs[document.type][0].files[0].size <= 2000000
        ) {
          console.log('ENTRO 2 ...', self.$refs[document.type][0].files[0])
          files[document.type] = self.$refs[document.type][0].files[0]
        } else if (
          self.$refs[document.type][0].files[0].type !== 'application/pdf'
        ) {
          alert('Error. ' + i18n.t('descriptions.pdf_format'))
          return false
        } else if (self.$refs[document.type][0].files[0].size > 2000000) {
          alert('Error. ' + i18n.t('descriptions.file_size', { s: '2MB' }))
          return false
        }
      }

      this.$store
        .dispatch('upload', {
          files: files,
          id: this.user.participant_id,
          type: document.type
        })
        .then(function (response) {
          if (response.status) {
            let doc = response.data[document.type]

            self.$store
              .dispatch('person/campusUpdateDocument', {
                campus_id: self.user.event_id,
                participant_id: self.user.participant_id,
                document: doc,
                document_type:
                  document.type !== 'image-rights'
                    ? document.type
                    : 'image_right',
                status: 1
              })
              .then(function (response) {
                self.load()
              })
          }
        })
    },

    selectImage (document) {
      console.log('CLICK', document.type)
      let aux = { ...document }
      aux.upload = aux.upload ? aux.upload + 1 : 0
      document = { ...aux }
      this.$refs[document.type][0].click()
    },

    previewDocument (document) {
      window.open(document.preview + '?' + moment().unix())
    }
  }
}
</script>

<style lang="scss">
#campus-documents {
  h5,
  .download {
    display: inline-block;
  }
  .download {
    cursor: pointer;
    font-weight: bold;
    text-decoration: underline;
  }
  .title {
    font-size: 24px !important;
    font-weight: bold;
  }
  .container {
    padding: 0;
    margin: 20px 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    .row {
      width: 48%;
      padding: 10px;
      margin: 10px 0;

      .doc-actions {
        flex-wrap: wrap;
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        flex-direction: row;
        -webkit-box-pack: justify;
        justify-content: center;
        width: 100%;

        .item {
          display: inline-block;
          height: 100% !important;
          margin: 3px;
          vertical-align: middle;
          text-align: center;

          button {
            width: 125px !important;
            padding: 0;
            margin: 0;
            height: 100%;
            min-width: 40px;
            outline: none;
            cursor: pointer;
            font-size: 8pt;
            font-family: Speedee-Bold;
            // margin-top: 5px;
            border-radius: 3px;
            border: 1px solid #fc8926;
            text-transform: uppercase;
            background-color: transparent;
            color: #fff;
            height: 40px;
            padding: 0;
            font-family: Roboto-Bold;
            font-size: 14px;
            line-height: 14px;
            transition: background-color 0.5s ease;
            vertical-align: middle;
            margin: 0 auto;
            background-color: #fc8926;

            &:hover {
              background-color: #e78026;
              border-color: #e78026;
            }
          }

          .secondary {
            background-color: white;
            color: #c55c00;
            border: 2px solid #fc8926;
            transition: 0.25s ease;
            &:hover {
              background-color: #fc8a2623 !important;
              color: white;
            }
          }
        }
      }
      .description {
        width: auto;
      }
      div {
        .bold {
          font-weight: bold;
        }
      }
    }
    .instructions {
      span {
        display: block;
      }
    }
  }

  .default {
    background-color: rgb(240, 240, 240);
  }

  .to_validate {
    border: 2px solid #b7aa0b;
    background-color: rgb(252, 255, 225);
  }

  .validated {
    border: 2px solid #09b509;
    background-color: rgb(220, 255, 220);
  }

  .error_document {
    border: 2px solid #920808;
    background-color: rgb(255, 212, 212);
  }
}

@include media("<desktop") {
  #campus-documents {
    .container {
      .row {
        width: 100%;
        .item {
          margin: 5px 0;
          // width: 100%;
          button {
            width: 80% !important;
          }
        }
      }
    }
  }
}

span.info {
  font-size: 16px;
  font-weight: bold;
}

#info_documents {
  padding: 0 12px !important;
  display: inline-block;

  .row {
    background-color: #f5f5f5;
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    margin-bottom: 24px;
    padding: 6px 12px;
    height: auto;
    // min-height: 100px;

    .item {
      display: inline-block;
      margin-bottom: 6px;
      width: 100%;
      vertical-align: top;
      &.mid {
        width: 50%;
        float: left;
      }

      .alergy,
      .campus {
        color: inherit;
        font-size: inherit;
        font-weight: inherit;

        &:after {
          content: ", ";
        }
        &:last-of-type:after {
          content: "";
        }
      }

      .campus {
        display: block;
      }
    }

    .label,
    .value {
      display: inline-block;
      font-size: 15px;
    }
    .label {
      width: fit-content;
      text-align: right;
      margin-right: 12px;
      text-transform: uppercase;
      font-size: 12px;

      &:after {
        content: ":";
      }
    }
    .value {
      font-weight: bold;
      display: inline;
    }

    #campus {
      .label,
      .value {
        display: inline-block;
      }
    }
  }

  .title {
    font-size: 16px !important;
    font-weight: bold;
    color: $main-color-t30;
    display: block;
    width: 100%;
    margin: 6px;

    &.sub {
      margin-left: 12px;
    }
  }

  .person {
    background: none;
    width: 100%;
    overflow: hidden;
    text-align: left;

    .person-role,
    .person-name {
      @include text-ellipsis();
      display: block;
      font-size: 24px;
      color: $main-color;
      width: 100%;
      padding: 2px;
    }

    .person-role {
      margin-right: 6px;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 16px;
      line-height: 16px;
    }
  }

  .left,
  .right {
    display: inline-block;
    padding: 12px;
  }
  .left {
    width: 60%;
  }
  .right {
    width: 40%;
  }
}

.v-snack__content {
  background-color: #ee7e1c;
  color: #000;
  font-family: "Roboto-Light";
  font-size: 16px;
}

@include media("<=desktop") {
  #info_documents {
    padding: 12px !important;

    .left,
    .right {
      width: 100%;
      display: block;
      padding: 0;
    }

    .row {
      .item {
        &.mid {
          width: 100%;
        }
      }
    }
  }
}

// @include media(">phone", "<tablet") {
//   #info_documents {
//   }
// }
</style>
